// noinspection DuplicatedCode
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import "react-datepicker/dist/react-datepicker.css";

import {cutiTransaksiSelector, getCutiReport, resetCutiSlice,} from "./cutiTransaksiSlice";

import {Colors} from "../../../../assets/Colors";
import DynamicTable from "../../../../components/tablecard/DynamicTable";
import BarGraph from "../../../../components/graph/GraphBuilder";
import {Card} from "@material-tailwind/react";
import {HrdInputGenerator} from "../../../../components/form/HrdInputGenerator";
import {useForm} from "../../../../components/isRequired";
import {MonthNamer} from "../../../../components/date/MonthGetter";
import {downloadExcel} from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const fmtTgl = (v) => (v ? new Date(v).toLocaleDateString("id-ID") : "-");

// Header tabel transaksi cuti — satu baris per PENGAJUAN cuti (data yang
// sama dengan yg tampil di modal Detail /human-resource/transaksi/cuti).
// Hak Cuti & Saldo Akhir Cuti disisipkan dari data saldo tahunan per
// karyawan (lihat enrichment di useEffect isGetReport) supaya konteks
// saldo tetap terlihat tanpa perlu tabel terpisah.
const headerTransaksi = [
    {name: "Nik", key: "Nik"},
    {name: "Nama Karyawan", key: "NamaKaryawan", modifiers: "Text"},
    {name: "Jenis Cuti", key: "JenisCutiKet", modifiers: "Text"},
    {name: "Keperluan", key: "KeperluanCuti", modifiers: "Text"},
    {name: "Tanggal Mulai", key: "TanggalMulai", modifiers: "Date"},
    {name: "Tanggal Akhir", key: "TanggalAkhir", modifiers: "Date"},
    {name: "Jumlah Hari", key: "JumlahHari", modifiers: "Number"},
    {name: "Status", key: "StatusKet", modifiers: "Text"},
    {name: "Hak Cuti (Periode)", key: "HakCutiTahunIni", modifiers: "Number"},
    {name: "Saldo Akhir Cuti", key: "SaldoAkhirCutiTahunIni", modifiers: "Number"},
];

const CutiReport = ({}) => {
    let initialState = {
        bulan: new Date(),
        region: "L0001",
    };
    const validations = [];

    const {values, errors, touched, customHandler} = useForm(initialState, validations);

    const [statistic, setStatistic] = useState(null);

    // ── Tabel Transaksi Cuti (data individual per pengajuan, dari halaman
    // /human-resource/transaksi/cuti) ──
    const [allTransaksi, setAllTransaksi] = useState([]);
    const [searchTransaksi, setSearchTransaksi] = useState("");
    const [pageTransaksi, setPageTransaksi] = useState(1);
    const TRANSAKSI_PAGE_SIZE = 10;

    const cuti = useSelector(cutiTransaksiSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCutiReport({
            "tahun": values.bulan.getFullYear().toString(),
            "bulan": "",
            "region": values.region
        }));
    }, []);

    useEffect(() => {
        if (cuti.report.Statistic) {
            setStatistic(MonthNamer(cuti.report.Statistic));
        } else {
            setStatistic(MonthNamer([]));
        }
    }, [cuti]);

    useEffect(() => {
        if (cuti.isGetReport) {
            dispatch(resetCutiSlice({}));

            // Hak Cuti & Saldo Akhir sudah dihitung per pengajuan di backend
            // (kantong kontrak/tahun, sama dgn halaman transaksi cuti).
            const transaksi = (cuti.report.Transaksi || []).map((t) => ({
                ...t,
                HakCutiTahunIni: t.HakCuti,
                SaldoAkhirCutiTahunIni: t.SaldoAkhir,
            }));
            setAllTransaksi(transaksi);
            setSearchTransaksi("");
            setPageTransaksi(1);
        }
    }, [cuti.isGetReport]);

    // ── Search (client-side) + Pagination ──
    const filteredTransaksi = allTransaksi.filter((r) => {
        const kw = searchTransaksi.trim().toLowerCase();
        if (!kw) return true;
        return [r.Nik, r.NamaKaryawan, r.JenisCutiKet, r.KeperluanCuti, r.StatusKet]
            .some((v) => v && v.toString().toLowerCase().includes(kw));
    });
    const totalPageTransaksi = Math.max(1, Math.ceil(filteredTransaksi.length / TRANSAKSI_PAGE_SIZE));
    const safePageTransaksi = Math.min(pageTransaksi, totalPageTransaksi);
    const pageRowsTransaksi = filteredTransaksi.slice(
        (safePageTransaksi - 1) * TRANSAKSI_PAGE_SIZE,
        (safePageTransaksi - 1) * TRANSAKSI_PAGE_SIZE + TRANSAKSI_PAGE_SIZE
    );

    // ── Export (mengikuti hasil search yg tampil) ──
    const exportTransaksiHeader = headerTransaksi.map((h) => h.name);
    const exportTransaksiBody = () =>
        filteredTransaksi.map((r) =>
            headerTransaksi.map((h) => {
                const v = r[h.key];
                if (h.modifiers === "Date") return fmtTgl(v);
                return v ?? "";
            })
        );
    const handleExportTransaksiExcel = () => {
        if (!filteredTransaksi.length) return;
        downloadExcel({
            fileName: "Report_Transaksi_Cuti",
            sheet: "data",
            tablePayload: {header: exportTransaksiHeader, body: exportTransaksiBody()},
        });
    };
    const handleExportTransaksiPDF = () => {
        if (!filteredTransaksi.length) return;
        const doc = new jsPDF({orientation: "landscape"});
        doc.setFontSize(12);
        doc.text("Report Transaksi Cuti", 14, 14);
        autoTable(doc, {
            head: [exportTransaksiHeader],
            body: exportTransaksiBody(),
            startY: 20,
            styles: {fontSize: 8, cellPadding: 2},
            headStyles: {fillColor: [47, 85, 151], textColor: 255, fontStyle: "bold"},
        });
        doc.save("Report_Transaksi_Cuti.pdf");
    };

    const filterApi = () => {
        dispatch(getCutiReport({
            "tahun": values.bulan.getFullYear().toString(),
            "bulan": (values.bulan.getMonth() + 1).toString(),
            "region": values.region
        }));
        setStatistic(null);
        setAllTransaksi([]);
        setSearchTransaksi("");
        setPageTransaksi(1);
    };

    return (
        <>
            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <Card>
                                <div className="flex flex-row flex-wrap items-start justify-start w-1/2 px-2 py-2">
                                    <div className={"w-1/3"}>
                                        <HrdInputGenerator type={"region"} name={"region"} title={"Region"}
                                            value={values} required={true} onChange={customHandler}
                                            touched={touched} errors={errors} size={"full"} />
                                    </div>
                                    <div className={"w-1/3"}>
                                        <HrdInputGenerator type={"tahun"} name={"bulan"} title={"Tahun"}
                                            value={values} required={true} onChange={customHandler}
                                            touched={touched} errors={errors} size={"full"} />
                                    </div>
                                    <div className={"w-1/3"}>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Buka data</label>
                                        <button type="button" onClick={filterApi}
                                            className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2">
                                            Buka
                                        </button>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center content-center">
                                    <BarGraph name={"Jumlah Karyawan Cuti (Disetujui) per Bulan"} Statistic={statistic} />

                                    {/* ── Daftar Transaksi Cuti — satu baris per pengajuan cuti,
                                        sama dengan yg tampil di /human-resource/transaksi/cuti ── */}
                                    <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2 gap-2">
                                        <div className="flex flex-row gap-2 flex-wrap">
                                            <button onClick={handleExportTransaksiExcel}
                                                    className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-green-600 hover:bg-green-600 hover:text-white">
                                                Export Excel
                                            </button>
                                            <button onClick={handleExportTransaksiPDF}
                                                    className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-red-400 hover:bg-red-400 hover:text-white">
                                                Export PDF
                                            </button>
                                        </div>
                                        <div className="flex flex-row w-full sm:w-96">
                                            <input type="text" value={searchTransaksi}
                                                   onChange={(e) => {
                                                       setSearchTransaksi(e.target.value);
                                                       setPageTransaksi(1);
                                                   }}
                                                   placeholder="Cari Nik / Nama / Jenis Cuti / Status"
                                                   className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full h-[42px]"/>
                                        </div>
                                    </div>

                                    <DynamicTable withoutAttribut={true} data={pageRowsTransaksi} header={headerTransaksi}/>

                                    <div className="flex flex-row justify-between items-center gap-4 w-full px-4 py-4 text-sm text-gray-600">
                                        <span>{filteredTransaksi.length} data</span>
                                        <div className="flex items-center gap-4">
                                            <button onClick={() => setPageTransaksi((p) => Math.max(1, p - 1))}
                                                    disabled={safePageTransaksi <= 1}
                                                    className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev
                                            </button>
                                            <span>Page {safePageTransaksi} / {totalPageTransaksi}</span>
                                            <button
                                                onClick={() => setPageTransaksi((p) => Math.min(totalPageTransaksi, p + 1))}
                                                disabled={safePageTransaksi >= totalPageTransaksi}
                                                className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CutiReport;
